import { atom, selector } from 'recoil';

import { GRADING_ADMIN } from 'config';
import { Academy, AcademyState } from './Academy';
import { LoggedInState } from './LoggedIn';

export const gradingOverviewState = atom({
  key: 'GradingOverviewState',
  default: { academyId: null, data: null, errorDetail: null, updatedAt: null, loading: false }
});

export const gradingOverviewRefreshState = atom({
  key: 'GradingOverviewRefreshState',
  default: 0
});

export const gradingAcademyState = selector({
  key: 'GradingAcademy',
  get: ({ get }) => {
    const type = get(LoggedInState)?.user?.type;
    const reachable = GRADING_ADMIN && (type === 'T' || (type === 'A' && get(AcademyState) !== null));
    const academy = get(Academy);
    return reachable && academy?.id ? academy : null;
  }
});

function currentOverviewOf(get) {
  const synced = get(gradingOverviewState);
  const academyId = get(gradingAcademyState)?.id ?? null;
  return academyId !== null && synced.academyId === academyId ? synced.data : null;
}

export const gradingMenuSignalState = selector({
  key: 'GradingMenuSignal',
  get: ({ get }) => {
    const overview = currentOverviewOf(get);
    if (!overview) {
      return null;
    }
    if (get(LoggedInState)?.user?.type === 'A' && overview.health.level === 'alert') {
      return 'alert';
    }
    const stalled = overview.exams.some((exam) => exam.badges.some((badge) => badge.kind === 'stimulus-review'));
    return overview.health.level === 'blocked' || stalled ? 'stalled' : null;
  }
});

export const gradingExamIdsState = selector({
  key: 'GradingExamIds',
  get: ({ get }) =>
    (currentOverviewOf(get)?.exams ?? [])
      .map((exam) => exam.examId)
      .sort((a, b) => a - b)
      .join(',')
});

export const gradingReviewCountState = selector({
  key: 'GradingReviewCount',
  get: ({ get }) => currentOverviewOf(get)?.todo?.reviews?.count ?? 0
});

export const gradingNodesDownState = selector({
  key: 'GradingNodesDown',
  get: ({ get }) => (currentOverviewOf(get)?.nodes?.offline ?? 0) > 0
});
